import Callout from './Callout'
import IconButton from "./IconButton";
import PhotoWithCaption from "./PhotoWithCaption";

const contentTypes = {
  ContentfulArticle: PhotoWithCaption,
  ContentfulPage: IconButton,
  ContentfulCallout: Callout
};

export default contentTypes


// WEBPACK FOOTER //
// ./src/components/ItemGroup/contentTypes.js